export default "__VITE_ASSET__Dh7XCs07__"